import React, { useState, useRef } from "react";
import BaseApi from "../api/BaseApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../assets/styles/driverRegistration.css";
import axios from "axios";

export default function DriverRegistration() {
    const [form, setForm] = useState({
        isim: '',
        soyisim: '',
        eposta: '',
        telefon: '',
        dogumTarihi: '',
        sehir: '',
        kimlik: null,
        ehliyet: null,
        adliSicil: null,
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isValidName, setIsValidName] = useState(true);
    const [isValidSurname, setIsValidSurname] = useState(true);
    const [isValidEmail, setIsValidEmail] = useState(true);
    const [isValidPhone, setIsValidPhone] = useState(true);

    const kimlikRef = useRef(null)
    const ehliyetRef = useRef(null)
    const adliSicilRef = useRef(null)
    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (files) {
            setForm({ ...form, [name]: files[0] });
        } else {
            setForm({ ...form, [name]: value });
        }

        switch (name) {
            case 'isim':
                setIsValidName(true);
                break;
            case 'soyisim':
                setIsValidSurname(true);
                break;
            case 'eposta':
                setIsValidEmail(true);
                break;
            case 'telefon':
                setIsValidPhone(true);
                break;
            default:
                break;
        }
    };

    const validateForm = () => {
        let isValid = true;

        if (form.isim.length < 2 || form.isim.length > 20) {
            setIsValidName(false);
            isValid = false;
        }

        if (form.soyisim.length < 2 || form.soyisim.length > 20) {
            setIsValidSurname(false);
            isValid = false;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(form.eposta)) {
            setIsValidEmail(false);
            isValid = false;
        }

        const phoneRegex = /^5[0-9]{9}$/;
        if (!phoneRegex.test(form.telefon.replace(/\D/g, ''))) {
            setIsValidPhone(false);
            isValid = false;
        }

        if (!form.kimlik || !form.ehliyet || !form.adliSicil) {
            toast.error("Lütfen tüm belgeleri yükleyiniz.");
            isValid = false;
        }

        return isValid;
    };

    const handleSubmit = async (e) => {
        debugger
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setIsSubmitting(true);

        try {
            const formData = new FormData();

            formData.append("name", form.isim);
            formData.append("surname", form.soyisim);
            formData.append("email", form.eposta);
            formData.append("mobileNum", form.telefon);
            formData.append("birthDate", form.dogumTarihi);
            formData.append("city", form.sehir);
            formData.append("onlyDriver", "true");

            if (form.kimlik) {
                formData.append("identity", form.kimlik);
            }
            if (form.ehliyet) {
                formData.append("license", form.ehliyet);
            }
            if (form.adliSicil) {
                formData.append("criminalRecord", form.adliSicil);
            }

            for (let [key, value] of formData.entries()) {
                console.log(`${key}:`, value);
            }

            const response = await axios.post("https://api.bid.az/registration/driver", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.data.statusCode === 200) {
                const successMessage = response.data.message || "Başvurunuz başarıyla gönderildi!";
                toast.success(successMessage, {
                    autoClose: 5000
                });

                setForm({
                    isim: '',
                    soyisim: '',
                    eposta: '',
                    telefon: '',
                    dogumTarihi: '',
                    sehir: '',
                    kimlik: null,
                    ehliyet: null,
                    adliSicil: null,
                });
                if (kimlikRef.current) kimlikRef.current.value = '';
                if (ehliyetRef.current) ehliyetRef.current.value = '';
                if (adliSicilRef.current) adliSicilRef.current.value = '';
            } else {
                const errorMessage = response.data.message || "Bir hata oluştu. Lütfen tekrar deneyin.";
                toast.error(errorMessage, { autoClose: 5000 });
            }
        } catch (error) {
            console.error("Registration error:", error);

            if (error.response) {
                const backendError = error.response.data;

                if (backendError.statusCode === 500) {
                    toast.error(backendError.message || "Kayıt işlemi başarısız oldu.", { autoClose: 5000 });
                } else if (backendError.message) {
                    toast.error(backendError.message, { autoClose: 5000 });
                } else {
                    toast.error("Sunucu hatası oluştu. Lütfen daha sonra tekrar deneyin.", { autoClose: 5000 });
                }
            } else if (error.request) {
                toast.error("Sunucuya bağlanılamıyor. İnternet bağlantınızı kontrol edin.", { autoClose: 5000 });
            } else {
                toast.error("Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.", { autoClose: 5000 });
            }
        } finally {
            setIsSubmitting(false);
        }
    };



    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className="container">
                <h1>Sürücü Kayıt Formu</h1>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>İsim *</label>
                        <input
                            type="text"
                            name="isim"
                            value={form.isim}
                            onChange={handleChange}
                            placeholder="Adınızı giriniz"
                            required
                            className={!isValidName ? "error" : ""}
                            disabled={isSubmitting}
                        />
                        {!isValidName && (
                            <div className="error-message">
                                İsim 2-20 karakter arasında olmalıdır
                            </div>
                        )}
                    </div>

                    <div className="form-group">
                        <label>Soyisim *</label>
                        <input
                            type="text"
                            name="soyisim"
                            value={form.soyisim}
                            onChange={handleChange}
                            placeholder="Soyadınızı giriniz"
                            required
                            className={!isValidSurname ? "error" : ""}
                            disabled={isSubmitting}
                        />
                        {!isValidSurname && (
                            <div className="error-message">
                                Soyisim 2-20 karakter arasında olmalıdır
                            </div>
                        )}
                    </div>

                    <div className="form-group">
                        <label>E-posta </label>
                        <input
                            type="email"
                            name="eposta"
                            value={form.eposta}
                            onChange={handleChange}
                            placeholder="email@example.com"
                            className={!isValidEmail ? "error" : ""}
                            disabled={isSubmitting}
                        />
                        {!isValidEmail && (
                            <div className="error-message">
                                Lütfen geçerli bir e-posta adresi giriniz
                            </div>
                        )}
                    </div>

                    <div className="form-group">
                        <label>Telefon *</label>
                        <input
                            type="tel"
                            name="telefon"
                            value={form.telefon}
                            onChange={handleChange}
                            placeholder="5XX XXX XX XX"
                            required
                            className={!isValidPhone ? "error" : ""}
                            disabled={isSubmitting}
                        />
                        {!isValidPhone && (
                            <div className="error-message">
                                Lütfen geçerli bir telefon numarası giriniz (5XXXXXXXXX)
                            </div>
                        )}
                    </div>

                    <div className="form-group">
                        <label>Doğum Tarihi *</label>
                        <input
                            type="date"
                            name="dogumTarihi"
                            value={form.dogumTarihi}
                            onChange={handleChange}
                            required
                            disabled={isSubmitting}
                        />
                    </div>

                    <div className="form-group">
                        <label>Şehir *</label>
                        <input
                            type="text"
                            name="sehir"
                            value={form.sehir}
                            onChange={handleChange}
                            placeholder="Yaşadığınız şehir"
                            required
                            disabled={isSubmitting}
                        />
                    </div>

                    <div className="form-group file-input-group">
                        <label>Kimlik *</label>
                        <input
                            ref={kimlikRef}
                            type="file"
                            name="kimlik"
                            accept=".pdf,.jpg,.jpeg,.png"
                            onChange={handleChange}
                            required
                            disabled={isSubmitting}
                        />
                    </div>

                    <div className="form-group file-input-group">
                        <label>Ehliyet *</label>
                        <input
                            ref={ehliyetRef}
                            type="file"
                            name="ehliyet"
                            accept=".pdf,.jpg,.jpeg,.png"
                            onChange={handleChange}
                            required
                            disabled={isSubmitting}
                        />
                    </div>

                    <div className="form-group file-input-group">
                        <label>Adli Sicil Kaydı *</label>
                        <input
                            ref={adliSicilRef}
                            type="file"
                            name="adliSicil"
                            accept=".pdf,.jpg,.jpeg,.png"
                            onChange={handleChange}
                            required
                            disabled={isSubmitting}
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className={isSubmitting ? 'loading' : ''}
                    >
                        {isSubmitting ? 'Gönderiliyor...' : 'Kaydol'}
                    </button>
                </form>
                <h4 style={{ marginTop: 15 }}>
                    Herhangi bir sorun yaşarsanız WhatsApp üzerinden bu numaradan bize ulaşabilirsiniz.
                    <a href="tel:05382392202">05382392202 </a>
                </h4>
            </div>
        </>
    );
}